import React from "react";
import { render } from "react-dom";
import Cutlist from "./Cutlist";
import { Provider } from "unstated";

const App = () => (
  <Provider>
    <Cutlist />
  </Provider>
);

render(<App />, document.getElementById("root"));



// WEBPACK FOOTER //
// ./src/index.js